module.exports = __webpack_public_path__ + "static/media/resource-ppt.4a982a1f.svg";